import React from 'react'
import { Title } from '@devexpress/dx-react-chart-material-ui'
import { useStyles } from './styles'
import Help from '@material-ui/icons/Help'

const titleStyle = { margin: 'auto' }
const TitleText = props => {
  const classes = useStyles()
  return (
    <div className={classes.titleContainer}>
      <div className={classes.text}>
        <Title.Text {...props} style={titleStyle} />
      </div>
      <div className={classes.icon}>
        <Help
          viewBox='0 0 26 26'
          titleAccess='This chart shows how your learners are progressing compared to the pace you set for the Wave (group). While learners are notified about how they’re doing, you may choose to prompt those that are behind via email or other channels.'
        />
      </div>
    </div>
  )
}

export default TitleText
